import { Collection } from "@mcleod/core";
import { ComponentConstructor, PanelProps } from "@mcleod/components";
import { AbstractComponentDemoExamples } from "./examples/AbstractComponentDemoExamples";
import { AbstractSectionPanel } from "./AbstractSectionPanel";
import { PropertyLineHeaderPanel } from "./PropertyLineHeaderPanel";
import { PropertyLinePanel } from "./PropertyLinePanel";

export class PropertySectionPanel extends AbstractSectionPanel {
    constructor(title: string, propDefs: Collection<any>, examples: AbstractComponentDemoExamples,
        componentClassRef: ComponentConstructor, componentName: string, props?: Partial<PanelProps>) {
        super(title, propDefs, examples, componentClassRef, componentName, props);
    }

    protected override getLineHeaderPanelClass(): ComponentConstructor {
        return PropertyLineHeaderPanel;
    }
    protected override getLinePanelClass(): ComponentConstructor {
        return PropertyLinePanel;
    }
}
